import { render, staticRenderFns } from "./prosperity-list.vue?vue&type=template&id=35201f29&scoped=true&"
import script from "./prosperity-list.vue?vue&type=script&lang=js&"
export * from "./prosperity-list.vue?vue&type=script&lang=js&"
import style0 from "./prosperity-list.vue?vue&type=style&index=0&id=35201f29&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35201f29",
  null
  
)

export default component.exports